import { Component, computed, input, output } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { ReportKpiTileSeverity } from '../../../Types/report-kpi-tile-severity.type';
import { EM_DASH } from '../../../Consts/em-dash.const';

@Component({
  selector: 'app-report-kpi-tile',
  standalone: true,
  imports: [COMMON_IMPORTS],
  templateUrl: './report-kpi-tile.component.html',
  styleUrl: './report-kpi-tile.component.scss',
})
export class ReportKpiTileComponent {
  readonly icon = input.required<string>();
  readonly labelKey = input.required<string>();
  readonly value = input.required<string | number | null>();
  readonly percent = input<number | null>(null);
  readonly severity = input<ReportKpiTileSeverity>('neutral');
  readonly warning = input(false);

  readonly tileClick = output<void>();

  readonly displayValue = computed(() => this.formatValue(this.value()));
  readonly displayPercent = computed(() => this.formatPercent(this.percent()));

  onTileClick(): void {
    this.tileClick.emit();
  }

  private formatValue(value: string | number | null): string {
    if (value === null || value === undefined || value === '') return EM_DASH;
    return String(value);
  }

  private formatPercent(percent: number | null): string {
    if (percent === null || percent === undefined || Number.isNaN(percent)) return EM_DASH;
    return `${Math.round(percent * 100)}%`;
  }
}
